/**
 * In-product CBT Learn more blurbs for Quick Clarity thinking patterns.
 * Decision-journal register; educational only — not homework.
 */

export const CBT_PATTERN_LEARN_MORE = {
  catastrophizing: {
    definition: "Treating a difficult outcome as certain, or far larger than the evidence supports.",
    example: "One delayed reply becomes “this relationship is over.”",
    thoughtCheck: "What outcome is supported by facts you have now, versus outcomes you are predicting?",
    question: "If you rated belief in the worst-case outcome 0–100, what evidence would move that number?"
  },
  mind_reading: {
    definition: "Assuming you know another person’s thoughts or motives without direct evidence.",
    example: "They didn’t smile, so they must disapprove of me.",
    thoughtCheck: "Which parts are observable behavior, and which parts are inferred meaning?",
    question: "What alternative interpretations fit the same observable facts?"
  },
  fortune_telling: {
    definition: "Predicting a future outcome as if it were already decided.",
    example: "If I raise this issue, it will definitely go badly.",
    thoughtCheck: "What have you verified about the future versus what you are forecasting?",
    question: "What small test would give you one new fact before deciding?"
  },
  all_or_nothing: {
    definition: "Sorting situations into only two categories (success/failure, good/bad) with no middle.",
    example: "If this meeting isn’t perfect, the whole week is ruined.",
    thoughtCheck: "Where does a partial success or mixed outcome fit?",
    question: "What would a ‘good enough’ result look like on a 0–100 scale?"
  },
  overgeneralization: {
    definition: "Taking one event as proof of a broad, lasting rule.",
    example: "This rejection means I always fail at pitching.",
    thoughtCheck: "How many instances support the rule, and how many contradict it?",
    question: "What is the specific situation, without the ‘always/never’ language?"
  },
  personalization: {
    definition: "Assigning yourself undue responsibility for events outside your control.",
    example: "The project slipped, so it must be because I’m not good enough.",
    thoughtCheck: "Which factors were yours to influence, and which were not?",
    question: "What share of the outcome would a neutral colleague attribute to you?"
  },
  labeling: {
    definition: "Turning one action or moment into a fixed identity statement.",
    example: "I missed one deadline, so I’m incompetent.",
    thoughtCheck: "What did you do in this situation, versus who you are as a person?",
    question: "How would you describe the same event as a behavior, not a label?"
  },
  emotional_reasoning: {
    definition: "Treating a feeling as proof that an interpretation is true.",
    example: "I feel anxious, so something must be wrong.",
    thoughtCheck: "What facts exist independent of the feeling’s intensity?",
    question: "If the feeling dropped by 20 points, would the evidence change?"
  },
  should_statements: {
    definition: "Rigid rules about how you or others must act, creating pressure when reality differs.",
    example: "I should already have this figured out.",
    thoughtCheck: "Is this a preference, a value, or an inflexible rule?",
    question: "What happens if you replace ‘should’ with ‘I prefer’ or ‘it would help if’?"
  },
  mental_filtering: {
    definition: "Focusing on one negative detail while filtering out broader context.",
    example: "One critical comment erases three clear acknowledgments.",
    thoughtCheck: "What information sits outside the detail you are zoomed in on?",
    question: "If you listed supporting and opposing evidence side by side, what appears?"
  },
  discounting_the_positive: {
    definition: "Dismissing useful or positive evidence so a negative interpretation stays intact.",
    example: "They complimented the work, but they were just being polite.",
    thoughtCheck: "What positive evidence are you setting aside, and on what basis?",
    question: "What would it take for positive evidence to count at face value?"
  }
};

export function getCbtPatternLearnMore(key) {
  if (!key) return null;
  return CBT_PATTERN_LEARN_MORE[key] || null;
}
